import React from 'react';
import './header.less';
import logo from '@/assets/imgs/walmart.png';
import user from '@/assets/imgs/user.png';
import line from '@/assets/imgs/line.png';
import { formatDate, getWeekday } from '@/utils';
import { Dropdown, DropdownOption } from 'tdesign-react';
import { CaretDownSmallIcon } from 'tdesign-icons-react';
import { useGlobalStore } from '@/stores/context';
import { useNavigate } from 'react-router-dom';
import { PageStatus } from '@/stores/provider';


const MyHeader: React.FC = () => {
  const {
    dispatch,
  } = useGlobalStore();
  const navigate = useNavigate();
  const handleClick = (v: DropdownOption) => {
    if (v.value === 1) {
      // 处理退出登录逻辑
      sessionStorage.removeItem('videoAudit-token');
      sessionStorage.removeItem('videoAudit-userInfoList');
      sessionStorage.removeItem('videoAudit-pageStatus');
      sessionStorage.removeItem('videoAudit-site');
      dispatch({
        type: 'setData',
        data: {
          pageStatus: PageStatus.NOLOGIN,
        }
      });
      navigate('/login', { replace: true });
    }
  };
  return (
    <div className="my-header">
      <div className="my-header-left">
        <img src={logo} alt="logo" />
      </div>
      <div className="my-header-right">
        <div className="my-header-right-item">
          {formatDate(new Date(), 'YYYY年MM月DD日')}
        </div>
        <div className="my-header-right-item">
          {getWeekday()}
        </div>
        <div className="my-header-right-item">
          <Dropdown
            direction="right"
            hideAfterItemClick
            options={[
              {
                content: '退出登录',
                value: 1
              },
            ]}
            placement="bottom-left"
            trigger="hover"
            onClick={handleClick}
          >
            <div className='my-header-right-item-dropdown'>
              <img src={user} alt="user" />
              {/* <div>我卖家</div> */}
              <CaretDownSmallIcon />
              <img src={line} width={20}></img>
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default MyHeader;
